import {PROVIDER_FLAGS} from '@Constants/index.constants.js';

export const ViewConsultationState = {
	url: '/consultation/:customerToken/:serviceProviderId/:consultationId',
	title: 'Consultation Comparison',
	params: {customerToken: null, serviceProviderId: null, consultationId: null},
	// One state, one URL: the v2 provider flag decides which component renders. This state is
	// in publicStates, so getPresentationFlags reads the flag from the customer endpoint,
	// which needs the customerToken, serviceProviderId and consultationId already in the URL.
	templateProvider: [
		'providerFlags',
		providerFlags =>
			providerFlags?.[PROVIDER_FLAGS.PRESENTATION_V2]
				? '<view-consultation-v2></view-consultation-v2>'
				: '<view-consultation></view-consultation>',
	],
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		const RoutesSvc = $transition$.injector().get('RoutesResolveSvc');
		return RoutesSvc.getPresentationFlags({trans: $transition$})
			.catch(() => ({}))
			.then(flags =>
				flags?.[PROVIDER_FLAGS.PRESENTATION_V2]
					? import(
							/* webpackChunkName: "viewConsultationV2Mod" */
							'@Containers/view-consultation-page/view-consultation-v2.cmp.js'
						)
					: import(
							/* webpackChunkName: "viewConsultationPageMod" */
							'@Containers/view-consultation-page/view-consultation.cmp.js'
						)
			)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
	resolve: [
		{
			token: 'canView',
			policy: {when: 'EAGER'},
			deps: ['RoutesResolveSvc', '$transition$'],
			resolveFn: (RoutesSvc, trans) =>
				RoutesSvc.validateConsultationPublic({status: 'presented', ...trans.params()}).catch(state =>
					trans.router.stateService.go(state.name, state.params)
				),
		},
		{
			token: 'providerFlags',
			policy: {when: 'LAZY'},
			deps: ['RoutesResolveSvc', '$transition$'],
			resolveFn: (RoutesSvc, trans) => RoutesSvc.getPresentationFlags({trans}),
		},
	],
};
